import { render } from "./SearchPointExchangeMagnification.vue?vue&type=template&id=ec7a941e&scoped=true&ts=true"
import script from "./SearchPointExchangeMagnification.vue?vue&type=script&lang=ts"
export * from "./SearchPointExchangeMagnification.vue?vue&type=script&lang=ts"

import "./SearchPointExchangeMagnification.vue?vue&type=style&index=0&id=ec7a941e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7a941e"]])

export default __exports__